import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface FormFieldProps {
  label: string;
  htmlFor?: string;
  required?: boolean;
  error?: string;
  hint?: string;
  children: ReactNode;
  className?: string;
}

export function FormField({
  label,
  htmlFor,
  required,
  error,
  hint,
  children,
  className,
}: FormFieldProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      <label
        htmlFor={htmlFor}
        className="text-[11px] font-semibold uppercase tracking-wider text-neutral-muted"
      >
        {label}
        {required && <span className="ml-1 text-orange">*</span>}
      </label>
      {children}
      {error ? (
        <p className="text-xs text-orange">{error}</p>
      ) : hint ? (
        <p className="text-xs text-neutral-muted">{hint}</p>
      ) : null}
    </div>
  );
}
